import { render, staticRenderFns } from "./GalleryStack.vue?vue&type=template&id=6f367942&scoped=true&"
import script from "./GalleryStack.vue?vue&type=script&lang=js&"
export * from "./GalleryStack.vue?vue&type=script&lang=js&"
import style0 from "./GalleryStack.vue?vue&type=style&index=0&id=6f367942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f367942",
  null
  
)

export default component.exports